require('../services/user-service.js');
require('../controllers/update-password-ctrl.js');
require('../controllers/update-password-hint-ctrl.js');


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/page-entries/update-password-entry.js
// module id = 512
// module chunks = 21